export function getCookie(cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  // console.log(ca);
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim()
    // console.log();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
  }
  return ''
}

export function setCookie(cname, cvalue, exdays) {
  // var d = new Date();
  // d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  // var expires = "expires=" + d.toGMTString();
  document.cookie = cname + '=' + cvalue + '; '
}

export function clearCookie() {
  document.cookie = 'username='
  document.cookie = 'key='
  document.cookie = 'name='
  document.cookie = 'phone='
  document.cookie = 'campusId='
}



// WEBPACK FOOTER //
// ./src/assets/js/cookie.js